import {Theme} from '@mui/material';

/**
 * 
 * @returns CcfAppSpaceStyles
 * @example - CcfAppSpaceStyles()
 */
export default (theme: Theme) => ({
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxHeight: '56px',
    height: '56px',
    background: (theme: Theme) => `linear-gradient(
      180deg, #009eda 0%, ${theme.palette.primary.main} 100%
    )
    0% 0% no-repeat padding-box`,
  },
  button: {
    margin: '0 4px 0 4px',
    padding: '20px',
    ':hover, :focus, :focus-visible': {
      outline: 'none',
      backgroundColor: 'rgba(255, 255, 255, .2)',
      borderRadius: '25%',
    },
  },
  helpIcon: {
    lineHeight: '1rem',
    padding: '7px 8px',
  },
  notificationBadge: {
    top: '2px',
    right: '5px',
    height: '14px',
    minWidth: '14px',
    fontSize: '9px !important',
    padding: '1px 2px 0px 2px !important',
    background: `${theme?.palette?.error?.main} 0% 0% no-repeat padding-box`,
  },
});
